import { useEffect, useState } from "react";
import "./Hero.css";

const heroImages = [
  "/image 1.jpeg",
  "/image 2.jpeg",
  "/image 3.jpeg",
  "/image 4.jpeg",
];

function Hero() {
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((previous) => {
        return (previous + 1) % heroImages.length;
      });
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="hero">

      {/* BACKGROUND SLIDES */}
      <div className="hero-slides">

        {heroImages.map((image, index) => (
          <div
            key={image}
            className={`hero-slide ${
              index === currentImage ? "active" : ""
            }`}
            style={{
              backgroundImage: `url("${image}")`,
            }}
          />
        ))}

      </div>

      {/* DARK OVERLAY */}
      <div className="hero-overlay"></div>


      {/* HERO CONTENT */}
      <div className="hero-container">

        <div className="hero-content">

          <div className="hero-label">
            <span></span>
            AFTER ACTION REVIEW
          </div>

          <h1>
            AAR <strong>LIBRARY</strong>
          </h1>

          <p>
            Learn from our projects. Explore outcomes, lessons,
            improvement actions and performance.
          </p>

          <div className="hero-features">

            <div className="hero-feature">
              <span>01</span>

              <div>
                <strong>SAFER</strong>
                <small>Operations</small>
              </div>
            </div>

            <div className="hero-feature">
              <span>02</span>

              <div>
                <strong>SMARTER</strong>
                <small>Decisions</small>
              </div>
            </div>

            <div className="hero-feature">
              <span>03</span>

              <div>
                <strong>STRONGER</strong>
                <small>Together</small>
              </div>
            </div>

          </div>

        </div>


        {/* SIDE MESSAGE */}
        <div className="hero-side-text">

          <span></span>

          <p>
            REAL PROJECTS.<br />
            REAL LEARNING.<br />
            A STRONGER TOMORROW.
          </p>

        </div>

      </div>


      {/* SLIDE INDICATORS */}
      <div className="hero-indicators">

        {heroImages.map((_, index) => (
          <button
            key={index}
            className={
              index === currentImage ? "active" : ""
            }
            onClick={() => setCurrentImage(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}

      </div>

    </section>
  );
}

export default Hero;